import it from 'element-ui/lib/locale/lang/it';

// 意大利语(意大利)
export default {
  ...it,
  layout: {
    title: 'Accedi con il tuo Uniportal ID',
    tip: "Dopo aver effettuato l'accesso con un numero di cellulare non registrato, il sistema si registrerà automaticamente",
    line: 'Altre opzioni di accesso',
  },
  button: {
    submit: 'Login/Registrazione',
    getCode: 'Ottieni codice',
    emailRegister: 'Registrati via e-mail',
    w3Login: "Accesso all'account W3",
    employeeLogin: 'Login dipendente',
    passwordLogin: 'Login con password',
    reSend: 'Reinvia',
    problem: 'Guida online',
    privacyPolicy: 'Informativa Sulla Privacy',
  },
  placeholder: {
    phoneNumber: 'Numero di telefono',
    verificationCode: 'Codice di verifica SMS',
  },
  dialog: {
    imgCode: "Inserire i caratteri dell'immagine.",
    userAgreements: {
      header: 'Accordo utente e Informativa sulla privacy',
      text1: `Leggi e accetta l'{privacy} e l'{agreement}.`,
      text2:
        'Informasi pribadi akan ditransfer ke anak perusahaan Huawei di luar negeri untuk diproses saat mengakses aplikasi Huawei di luar negeri. Untuk rincian, lihat {privacy}',
    },
    crossBorder: {
      header: "Suggerimenti per l'autorizzazione",
      text: "Il servizio locale utilizzato dall'utente non si trova nella stessa regione in cui l'account è registrato.L'accesso transfrontaliero alle informazioni sull'account richiede l'autorizzazione dell'utente.",
    },
    multiAccounts: 'Seleziona un account.',
    agreeButton: 'Accetta e continua',
    disagreeButton: 'Rifiuta',
    confirmButton: 'Conferma',
    cancelButton: 'Annullamento',
    knowMe: 'OK',
  },
  toast: {
    hasSend: 'Codice di verifica inviato.',
    wait: 'Un momento, per favore',
  },
  tooltip: {
    Huawei: 'Huawei ID',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Il codice CAPTCHA non può essere vuoto.',
    'IDC-03-0002': 'Il codice CAPTCHA è scaduto.',
    'IDC-00-0004': 'Codice CAPTCHA errato.',

    // 表单输入为空
    'IDC-01-00024': 'Il prefisso Paese è necessario per verificare il numero di telefono.',
    phoneNumberEmpty: 'Inserire il numero di telefono.',
    'IDC-03-00033': 'Inserisci il codice di verifica SMS.',

    // 表单数据错误
    'IDC-02-00227':
      'Il numero di cellulare inserito non corrisponde al paese/area geografica selezionata',
    'IDC-02-00226': 'Il prefisso del paese è vietato',
    'IDC-02-00029': 'Codice di verifica errato o scaduto',
    'IDC-02-0013': 'Accesso SMS non riuscito perché il codice di verifica non è corretto',
    'IDC-02-0020': 'Verifica non riuscita. Codice di verifica errato.',
    'IDC-02-00028': 'Il numero di cellulare deve contenere da 6 a 30 cifre',
    'IDC-02-00012': 'Nomor ponsel salah',

    // 错误操作锁定
    accountLock:
      'Numero di telefono o codice di verifica errato. {number} tentativi rimanenti. | Numero di telefono o codice di verifica errato. {number} tentativi rimanenti.',
    accountLocked:
      'Troppi tentativi falliti. Riprova tra {number} secondi. | Troppi tentativi falliti. Riprova tra {number} secondi.',
    operationRisk: "L'operazione presenta rischi per la sicurezza. Riprovare dopo {number} secondi.",

    // 频繁操作
    'IDC-02-00038': 'Riprova dopo 60 secondi.',
    'IDC-02-00064': 'Hai inviato il codice di verifica SMS troppo spesso. Riprova tra 24 ore.',
    'IDC-02-00211': "L'operazione presenta rischi per la sicurezza. Riprova più tardi.",
    'IDC-02-00212':
      'Il tuo numero di cellulare invia il codice di verifica SMS troppo spesso. Cambia il numero di cellulare o riprova 24 ore dopo.',
    'IDC-02-00213': 'Hai inviato il codice di verifica SMS troppo spesso. Riprova tra 24 ore.',
    'IDC-02-00215':
      'Il codice di verifica SMS viene inviato troppo frequentemente al tuo numero di cellulare. Cambia il numero di cellulare, seleziona un altro metodo di verifica o riprova 24 ore dopo.',
    'IDC-02-00228':
      'Il numero di volte in cui hai inviato il codice di verifica SMS è troppo frequente. Riprova tra 1 ora.',
    'IDC-02-00092': "L'operazione attuale è troppo frequente. Si prega di riprovare dopo 24 ore.",

    // 请求异常
    'IDC-10-00400': 'Eccezione richiesta cliente ',
    'IDC-10-00500': 'Errore di sistema interno ',
    'IDC-02-00264': 'Le richieste di accesso non autorizzate sono vietate',
    'IDC-02-00063': 'Parametro non valido',
    'IDC-03-0007':
      "L'operazione corrente presenta rischi per la sicurezza e non può essere registrata temporaneamente.", // 机翻
    'IDC-03-00057': "L'operazione attuale comporta rischi per la sicurezza.",

    // 页面过期
    'IDC-00-00017': 'La pagina è scaduta.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Indietro',
  closeButton: 'Chiudi',

  // 滑块验证相关：
  resourceReqFailed: 'Richiesta di risorse non riuscita. Aggiornare la pagina e riprovare.',
  verifyFailedAndPlsRetry: 'Verifica non riuscita, riprova',
  serviceErrAndPlsRetry: 'Eccezione di servizio. Riprova.',
  learnMore: 'Per saperne di più',
  cookieBannerText: 'Questo sito web utilizza i cookie per fornire la migliore esperienza possibile.',
};
